import { create } from 'zustand';

export type EmoiRole = 'user' | 'assistant';

export interface EmoiToolReceipt {
  name: string;
  args: Record<string, unknown>;
  text: string;
  success: boolean;
}

export interface EmoiMessage {
  id: string;
  role: EmoiRole;
  content: string;
  toolReceipts?: EmoiToolReceipt[];
  pending?: boolean;
  createdAt: number;
}

interface EmoiChatState {
  isOpen: boolean;
  isSending: boolean;
  messages: EmoiMessage[];
  open: () => void;
  close: () => void;
  toggle: () => void;
  reset: () => void;
  appendMessage: (msg: EmoiMessage) => void;
  patchMessage: (id: string, patch: Partial<EmoiMessage>) => void;
  setIsSending: (v: boolean) => void;
}

export const useEmoiChatStore = create<EmoiChatState>((set) => ({
  isOpen: false,
  isSending: false,
  messages: [],
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((s) => ({ isOpen: !s.isOpen })),
  reset: () => set({ messages: [], isSending: false }),
  appendMessage: (msg) => set((s) => ({ messages: [...s.messages, msg] })),
  patchMessage: (id, patch) =>
    set((s) => ({
      messages: s.messages.map((m) => (m.id === id ? { ...m, ...patch } : m)),
    })),
  setIsSending: (v) => set({ isSending: v }),
}));
